import {createFileRoute} from '@tanstack/react-router'
import {firstLevelLayoutRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/collection/$username/$primarySorting')({
    ...firstLevelLayoutRoute()
})
